import { App } from 'vue'
import RequestFormEvent from './RequestFormEvent.vue'
import RequestFormCourse from './RequestFormCourse.vue'
import RequestFormWrapper from './RequestFormWrapper.vue'
import Catalog from './Catalog.vue'
import UpcomingCatalog from './UpcomingCatalog.vue'
import RecordingsCatalog from './RecordingsCatalog.vue'
import BtnFiles from './BtnFiles.vue'
import BtnVideos from './BtnVideos.vue'
import BtnCertificate from './BtnCertificate.vue'
import TestController from './TestController.vue'
import EventScanner from './EventScanner.vue'
import RegistrationCard from './RegistrationCard.vue'
import RegistrationQrCard from './RegistrationQrCard.vue'

const register = (app: App<Element>): void => {
  app
    .component('event-request-form-event', RequestFormEvent)
    .component('event-request-form-course', RequestFormCourse)
    .component('event-request-form-wrapper', RequestFormWrapper)
    .component('event-catalog', Catalog)
    .component('upcoming-event-catalog', UpcomingCatalog)
    .component('recordings-catalog', RecordingsCatalog)
    .component('btn-files', BtnFiles)
    .component('btn-videos', BtnVideos)
    .component('btn-certificate', BtnCertificate)
    .component('test-controller', TestController)
    .component('event-scanner', EventScanner)
    .component('registration-card', RegistrationCard)
    .component('registration-qr-card', RegistrationQrCard)
}

export default {
  register,
}
